<template>
  <div class="org-stats-grid">
    <div class="stat-card">
      <div class="stat-icon-wrap blue">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      </div>
      <div class="stat-info">
        <span class="stat-label">顶级管理机构</span>
        <strong class="stat-val">{{ orgTree?.name || '店铺管理' }}</strong>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon-wrap violet">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>
      <div class="stat-info">
        <span class="stat-label">业务团队 / 分组</span>
        <strong class="stat-val">{{ totalGroups }} 个团队</strong>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon-wrap purple">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      </div>
      <div class="stat-info">
        <span class="stat-label">营业店铺总数</span>
        <strong class="stat-val">{{ totalStores }} 家门店</strong>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  orgTree: {
    type: Object,
    default: null,
  },
  totalGroups: {
    type: Number,
    default: 0,
  },
  totalStores: {
    type: Number,
    default: 0,
  },
});
</script>

<style scoped>
.org-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .org-stats-grid {
    grid-template-columns: 1fr;
  }
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid var(--border-color, #e2e8f0);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.stat-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.stat-icon-wrap.blue { background: #eff6ff; color: #2563eb; }
.stat-icon-wrap.violet { background: #f5f3ff; color: #7c3aed; }
.stat-icon-wrap.purple { background: #f5f3ff; color: #7c3aed; }

.stat-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-label {
  font-size: 12px;
  color: var(--text-muted, #64748b);
}

.stat-val {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-dark, #0f172a);
}
</style>
